var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "wheelAssembly",
      on: {
        click: function($event) {
          _vm.roundTheTableBelow = ""
        }
      }
    },
    [
      _c("div", { staticClass: "close" }, [
        _c("div", { staticClass: "operation" }, [
          _c("div", { on: { click: _vm.closingWheel } }, [
            _c("span", { staticClass: "iconfont icon-guanbi" })
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "state" },
        [
          _vm._m(0),
          _vm._v(" "),
          _vm._l(4, function(item) {
            return _c("span", { key: item }, [
              _vm._v(_vm._s(_vm.modifiableState[item - 1].state))
            ])
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { ref: "wheelAssemblyRef", staticClass: "roundList" },
        [
          _vm.wheelData.length
            ? _vm._l(_vm.wheelData, function(item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    ref: "roundListItemRef",
                    refInFor: true,
                    staticClass: "roundList_item"
                  },
                  [
                    _c("span", { staticClass: "wheel_title" }, [
                      _vm._v(_vm._s(item.wheelName))
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        ref: "employeeRef",
                        refInFor: true,
                        staticClass: "employee"
                      },
                      [
                        _vm._l(item.employeeList, function(staff, staffIndex) {
                          return _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "bag",
                                  rawName: "v-bag",
                                  value: staff.state,
                                  expression: "staff.state"
                                }
                              ],
                              key: staff.id,
                              staticClass: "employee_item",
                              on: {
                                touchstart: function($event) {
                                  $event.preventDefault()
                                  $event.stopPropagation()
                                  return _vm.pressEvent(
                                    $event,
                                    index + "-" + staffIndex
                                  )
                                },
                                mousedown: function($event) {
                                  $event.preventDefault()
                                  $event.stopPropagation()
                                  return _vm.pressEvent(
                                    $event,
                                    index + "-" + staffIndex
                                  )
                                },
                                click: function($event) {
                                  $event.stopPropagation()
                                }
                              }
                            },
                            [
                              _c("span", [_vm._v(_vm._s(staff.employeeNo))]),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(staff.employeeName))]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(staff.deltaT || "00:00:00"))
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "employee_top" }, [
                                _c(
                                  "span",
                                  { staticClass: "head" },
                                  [
                                    _c("svg-icon", {
                                      staticClass: "default_head",
                                      staticStyle: {
                                        "font-size": "25px",
                                        color: "#303133"
                                      },
                                      attrs: { "icon-class": "default_head" }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "icon" }, [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.getState(staff.state)))
                                  ]),
                                  _vm._v(" "),
                                  _c("span", {
                                    staticClass: "iconfont icon-xiala"
                                  })
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.roundTheTableBelow ===
                                        index + "-" + staffIndex,
                                      expression:
                                        "roundTheTableBelow === `${index}-${staffIndex}`"
                                    }
                                  ],
                                  staticClass: "popups",
                                  on: {
                                    mousedown: function($event) {
                                      $event.stopPropagation()
                                    },
                                    touchstart: function($event) {
                                      $event.stopPropagation()
                                    }
                                  }
                                },
                                _vm._l(_vm.modifiableState, function(
                                  item,
                                  $index
                                ) {
                                  return _c(
                                    "div",
                                    {
                                      key: $index,
                                      staticClass: "popups_item",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.updateStatus(
                                            item.value,
                                            index,
                                            staffIndex
                                          )
                                        }
                                      }
                                    },
                                    [_c("span", [_vm._v(_vm._s(item.state))])]
                                  )
                                }),
                                0
                              )
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            ref: "employeeAddRef",
                            refInFor: true,
                            staticClass: "employee_add",
                            on: {
                              click: function($event) {
                                return _vm.employeePopUpLayer(index)
                              }
                            }
                          },
                          [_c("span", { staticClass: "iconfont icon-tianjia" })]
                        )
                      ],
                      2
                    )
                  ]
                )
              })
            : [
                _c("div", { staticClass: "noData" }, [
                  _c(
                    "div",
                    {
                      staticClass: "onData_box",
                      on: { click: _vm.goToSettings }
                    },
                    [
                      _c("span", { staticClass: "iconfont icon-wushuju" }),
                      _vm._v(" "),
                      _c("span", [_vm._v("还未设置轮牌,")]),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            color: "#1E90FF",
                            "text-decoration": "underline",
                            cursor: "pointer",
                            "user-select": "none"
                          },
                          on: {
                            click: function($event) {
                              return _vm.$router.push({
                                name: "Memberstoresettings",
                                params: {
                                  type: "second"
                                }
                              })
                            }
                          }
                        },
                        [_vm._v("去设置")]
                      )
                    ]
                  )
                ])
              ]
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.employeeScreeningDialogBox,
              expression: "employeeScreeningDialogBox"
            }
          ],
          staticClass: "box_show",
          on: {
            click: function($event) {
              _vm.employeeScreeningDialogBox = false
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "screeningStaff",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                }
              }
            },
            [
              _c("div", { staticClass: "header" }, [
                _c("span", [_vm._v("选择员工")]),
                _vm._v(" "),
                _c("span", {
                  staticClass: "iconfont icon-guanbi",
                  on: {
                    click: function($event) {
                      _vm.employeeScreeningDialogBox = false
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "screenItem" },
                _vm._l(_vm.employeeDataList, function(item) {
                  return _c(
                    "div",
                    { key: item.id },
                    [
                      item.wheelEmployeeLists.length
                        ? [
                            _c("span", [_vm._v(_vm._s(item.postName))]),
                            _vm._v(" "),
                            _c(
                              "div",
                              _vm._l(item.wheelEmployeeLists, function(
                                subItem
                              ) {
                                return _c(
                                  "div",
                                  {
                                    key: subItem.id,
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.addStaff(subItem)
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      class: { active: subItem.sign }
                                    }),
                                    _vm._v(" "),
                                    _c("i", [
                                      _vm._v(
                                        _vm._s(
                                          subItem.employeeNo +
                                            " " +
                                            subItem.employeeName
                                        )
                                      )
                                    ])
                                  ]
                                )
                              }),
                              0
                            )
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c("div", { staticClass: "confirmAddition" }, [
                _c(
                  "span",
                  {
                    on: {
                      click: function($event) {
                        _vm.employeeScreeningDialogBox = false
                      }
                    }
                  },
                  [_vm._v("取 消")]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    class: { active: _vm.addedNumber },
                    on: { click: _vm.confirmAddition }
                  },
                  [_vm._v("添 加")]
                )
              ])
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("i", [
      _c("i", { staticClass: "iconfont icon-wushuju" }),
      _vm._v(" 手指按住卡片即可拖动卡片调整位置")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6b31d258", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b31d258","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/paperless/components/employeeRotation/index.vue
// module id = null
// module chunks = 